var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 33,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .843h24.775V32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .157)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.387 2.843C6.854 2.843 2 8.013 2 13.909c0 4.478 6.95 12.29 10.387 15.697 3.437-3.406 10.388-11.22 10.388-15.697 0-5.895-4.854-11.066-10.388-11.066m0 29.157a.996.996 0 01-.688-.274C11.221 31.273 0 20.55 0 13.909 0 6.826 5.673.843 12.387.843c6.715 0 12.388 5.983 12.388 13.066 0 6.642-11.222 17.364-11.7 17.817a.996.996 0 01-.688.274",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.387 9.543a3.787 3.787 0 00-3.783 3.783 3.787 3.787 0 003.783 3.783 3.788 3.788 0 003.784-3.783 3.788 3.788 0 00-3.784-3.783m0 9.566a5.79 5.79 0 01-5.783-5.783 5.79 5.79 0 015.783-5.783 5.79 5.79 0 015.784 5.783 5.79 5.79 0 01-5.784 5.783"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMap);
export default __webpack_public_path__ + "static/media/nav-map.774f8b2d70223a7af2d30bdab529642a.svg";
export { ForwardRef as ReactComponent };